// ── DESIGN TOKENS (matched to eagleworksai.com) ──
const C = {
  bg: "#0A1A2F",
  bgAlt: "#0d1f37",
  bgCard: "#0f2340",
  bgCardHover: "#132a4a",
  bgElevated: "#132a4a",
  border: "#1a3555",
  borderLight: "#234568",
  accent: "#ffffff",
  blue: "#5a9ef0",
  blueDim: "rgba(90,158,240,0.1)",
  blueBorder: "rgba(90,158,240,0.25)",
  amber: "#e8a838",
  amberDim: "rgba(232,168,56,0.08)",
  amberBorder: "rgba(232,168,56,0.2)",
  green: "#4ecb71",
  greenDim: "rgba(78,203,113,0.08)",
  greenBorder: "rgba(78,203,113,0.2)",
  red: "#e85454",
  redDim: "rgba(232,84,84,0.08)",
  redBorder: "rgba(232,84,84,0.2)",
  text: "#ffffff",
  textSec: "#c0cfe0",
  textMut: "#6a839e",
  r: 8,
};

export default C;
